import Loader from '@space-lib/components/loader'

const LoadingState = () => {
  return (
    <div className='_d-flex _flex-column _align-items-center _py-5 _px-8'>
      <Loader />
    </div>
  )
}

export default LoadingState
